module.exports = __webpack_public_path__ + "static/media/20.6e949da2.jpg";